"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var config_1 = require("../../util/config");
var link_1 = __importDefault(require("next/link"));
var styles_1 = require("./styles");
var react_use_1 = require("react-use");
function isPropsForAnchorElement(props) {
    return 'href' in props;
}
function isPropsForNextLink(props) {
    return 'href' in props || 'to' in props;
}
var ButtonContents = function (_a) {
    var startIcon = _a.startIcon, endIcon = _a.endIcon, children = _a.children, loading = _a.loading;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && (react_1.default.createElement(styles_1.LoadingContainer, null,
            react_1.default.createElement(styles_1.Loading, null))),
        !loading && startIcon,
        children,
        !loading && endIcon));
};
var ButtonLike = function (_a) {
    var children = _a.children, secondary = _a.secondary, width = _a.width, disabled = _a.disabled, color = _a.color, bold = _a.bold, strike = _a.strike, underline = _a.underline, variant = _a.variant, startIcon = _a.startIcon, endIcon = _a.endIcon, fullWidth = _a.fullWidth, loading = _a.loading, padded = _a.padded, weight = _a.weight, handleClick = _a.onClick, trackingEvent = _a.trackingEvent, trackingEventProps = _a.trackingEventProps, handleOnTrack = _a.onTrack, rest = __rest(_a, ["children", "secondary", "width", "disabled", "color", "bold", "strike", "underline", "variant", "startIcon", "endIcon", "fullWidth", "loading", "padded", "weight", "onClick", "trackingEvent", "trackingEventProps", "onTrack"]);
    var _b = (0, react_1.useContext)(config_1.ChocolatesContext), ssrCompatible = _b.ssr, onTrack = _b.onTrack;
    var href = rest.href || rest.to;
    var ref = (0, react_1.useRef)();
    var isDoneRef = (0, react_1.useRef)(false);
    var _c = (0, react_1.useState)(trackingEventProps), trackingProps = _c[0], setTrackingProps = _c[1];
    (0, react_use_1.useDeepCompareEffect)(function () {
        setTrackingProps(trackingEventProps);
    }, [trackingEventProps !== null && trackingEventProps !== void 0 ? trackingEventProps : {}]);
    var contents = (react_1.default.createElement(ButtonContents, __assign({}, { loading: loading, children: children, startIcon: startIcon, endIcon: endIcon })));
    var beforeClick = (0, react_1.useCallback)(function (callback) {
        return function (e) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var track;
                return __generator(this, function (_b) {
                    if (isDoneRef.current === true) {
                        isDoneRef.current = false;
                    }
                    else {
                        e.preventDefault();
                        e.stopPropagation();
                        track = handleOnTrack !== null && handleOnTrack !== void 0 ? handleOnTrack : onTrack;
                        try {
                            track &&
                                trackingEvent &&
                                track({
                                    event: trackingEvent,
                                    properties: trackingProps,
                                });
                        }
                        finally {
                            isDoneRef.current = true;
                            callback === null || callback === void 0 ? void 0 : callback.apply(this, __spreadArray([e], args, true));
                            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click();
                        }
                    }
                    return [2 /*return*/];
                });
            });
        };
    }, [handleOnTrack, onTrack, trackingEvent, trackingProps]);
    var onClick = (0, react_1.useCallback)(beforeClick(handleClick), [
        beforeClick,
        handleClick,
    ]);
    return isPropsForAnchorElement(rest) &&
        rest.href &&
        (rest.href.includes('http') || !ssrCompatible) ? (react_1.default.createElement("a", __assign({ ref: ref, onClick: onClick, "aria-disabled": disabled || loading }, rest), contents)) : isPropsForNextLink(rest) && ssrCompatible ? (react_1.default.createElement(link_1.default, __assign({ ref: ref, onClick: onClick, href: href }, rest),
        react_1.default.createElement("a", { className: rest.className }, contents))) : (react_1.default.createElement("button", __assign({ ref: ref, onClick: onClick, disabled: disabled || loading }, rest), contents));
};
var Button = (0, styled_components_1.default)(ButtonLike)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case 'unstyled':
            return styles_1.UnstyledButtonStyles;
        case 'text':
            return styles_1.TextButtonStyles;
        case 'outlined':
            return styles_1.OutlinedButtonStyles;
        case 'filled':
        default:
            return styles_1.FilledButtonStyles;
    }
});
exports.default = Button;
var templateObject_1;
//# sourceMappingURL=index.js.map